import { makeStyles } from '@mui/styles';
import { Alert } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useCallback } from 'react';

const useStyles = makeStyles((theme: any) => ({
  toast: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
  },
}));

const useAlert = () => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const create = useCallback((
    message: string,
    severity: 'error' | 'success' | 'warning' | 'info',
    timeOut: number = 3000
  ) => enqueueSnackbar(message, {
    key: message,
    preventDuplicate: true,
    content: (key, _message) => (
      <Alert
        key={key}
        elevation={6}
        variant="filled"
        severity={severity}
        className={classes.toast}
      >
        {_message}
      </Alert>
    ),
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    autoHideDuration: timeOut,
  }), [classes, enqueueSnackbar]);

  return create;
};

export default useAlert;
